import { AppError } from './AppError';
import { ValidationError as ClassValidatorError } from 'class-validator';

/**
 * Error thrown when validation fails.
 */
export class ValidationError extends AppError {
  /**
   * Creates a new ValidationError instance.
   * @param message The error message.
   * @param validationErrors The validation errors from class-validator.
   */
  constructor(message: string = 'Validation failed', validationErrors?: ClassValidatorError[]) {
    super(message, 'VALIDATION_ERROR', true, validationErrors);
    this.name = 'ValidationError';
  }

  /**
   * Creates a ValidationError from class-validator validation errors.
   * @param validationErrors The validation errors from class-validator.
   * @returns A new ValidationError instance.
   */
  static fromValidationErrors(validationErrors: ClassValidatorError[]): ValidationError {
    const message = ValidationError.formatValidationErrors(validationErrors);
    return new ValidationError(message, validationErrors);
  }

  /**
   * Formats validation errors from class-validator into a readable message.
   * @param errors The validation errors from class-validator.
   * @returns A formatted error message.
   */
  static formatValidationErrors(errors: ClassValidatorError[]): string {
    return errors.map(({
      value,
      property,
      constraints
    }) => `${property} with value ${value}: does not meet: ${constraints && Object.entries(constraints).map(([k, v]) => `${k}: ${v}`).join(', ')}`).join('; ');
  }
}